import React from "react";
import DoctorsHero from "../sections/DoctorsHero";
import DoctorsCardSection from "../sections/DoctorsCardSection";
import Comment from "../sections/Comment";
import News from "../sections/News";
import Contact from "../sections/Contact";

const Doctors = () => {
  return (
    <div>
      <DoctorsHero />
      <DoctorsCardSection />
      <Comment />
      <News />
      <Contact />
    </div>
  );
};

export default Doctors;
